import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonical, ogType, ogImage, twitterHandle }) => {
  const siteName = "Sahajink Pvt Ltd";
  const fullTitle = `${title} | ${siteName}`;
  const defaultDescription = "Premium custom label printing solutions in Surat, India. ISO-certified manufacturer specializing in Pharma, Food, and Cosmetic labels. High-quality, fast turnaround, global shipping.";
  const defaultKeywords = "label printing solution, custom label printing surat, label printing company, label printing india, pharmaceutical labels, cosmetic labels, food labels, sahajink";

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType || 'website'} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      {twitterHandle && <meta name="twitter:site" content={twitterHandle} />}

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify([
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Sahajink Pvt Ltd",
            "image": ogImage || "https://sahajink.com/logo.png",
            "@id": "https://sahajink.com",
            "url": "https://sahajink.com",
            "telephone": "+916352424442",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Industrial Area, Phase II",
              "addressLocality": "Surat",
              "addressRegion": "Gujarat",
              "postalCode": "395006",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 21.1702,
              "longitude": 72.8311
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
              ],
              "opens": "09:00",
              "closes": "18:00"
            },
            "sameAs": [
              "https://www.linkedin.com/company/sahajink",
              "https://facebook.com/sahajink"
            ]
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Sahajink Pvt Ltd",
            "url": "https://sahajink.com",
            "logo": "https://sahajink.com/logo.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+916352424442",
              "contactType": "customer service",
              "areaServed": "Global",
              "availableLanguage": ["en", "hi", "gu"]
            }
          }
        ])}
      </script>
    </Helmet>
  );
};

export default SEO;
